module.exports = __webpack_public_path__ + "img/H03098-112.f919b779.jpg";